import playSvg from '../../svg/play.svg';

class Video {
	constructor(node) {
		this.node    = node;
		this.wrap    = this.node.querySelector('.wp-block-video__wrap');
		this.video   = this.node.querySelector('video');
		this.caption = this.node.querySelector('figcaption');

		if ( ! this.caption ) {
			this.caption = document.createElement('figcaption');
			this.wrap.appendChild(this.caption);
		}

		this.buttonBlock = document.createElement('div');
		this.buttonBlock.className = 'wp-block-button is-style-video';
		this.buttonBlock.insertAdjacentHTML('afterbegin', playSvg);
		this.caption.appendChild(this.buttonBlock);

		this.button = document.createElement('button');
		this.button.type = 'button';
		this.button.className = 'wp-block-button__link has-black-color has-white-background-color';
		this.button.appendChild(document.createTextNode('Play Video'));
		this.button.addEventListener('click', () => this.video.play());
		this.buttonBlock.appendChild(this.button);

		this.wrap.addEventListener('click', () => {
			if ( ! this.node.classList.contains( 'wp-block-video--playing' ) ) {
				this.video.play();
			}
		});

		this.video.addEventListener('play', () => {
			this.video.controls = 'controls';
			this.node.classList.add('wp-block-video--playing');
			this.node.classList.remove('wp-block-video--paused');
		});

		this.video.addEventListener('ended', () => {
			this.node.classList.remove('wp-block-video--playing');
			this.node.classList.remove('wp-block-video--paused');
			this.video.removeAttribute('controls');
		});

		this.video.addEventListener('pause', () => {
			this.node.classList.remove('wp-block-video--playing');
			this.node.classList.add('wp-block-video--paused');
		});

		this.node.addEventListener('mouseenter', () => {
			this.button.classList.add('hover');
		});

		this.node.addEventListener('mouseout', () => {
			this.button.classList.remove('hover');
		});

		this.video.removeAttribute('controls');
	}
}

/**
 * The media-text block outputs the video straight,
 * so we need to wrap it in our block markup and then instantiate
 */
Video.mediaText = function(video) {
	const block = document.createElement('div');
	block.className = 'wp-block-video';
	video.parentNode.insertBefore(block, video);
	block.appendChild(video);

	return new Video(block);
}

export default Video;
